/** Help panel quickbar syntax table and optional intro-restart section helpers. */
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  HELP_QUICKBAR_ROWS,
  HELP_QUICKBAR_FULL_EXAMPLE_KEY,
} from '@/components/layout/helpQuickbarTableData';

const helpTableSx = {
  tableLayout: 'fixed',
  width: '100%',
  '& .MuiTableCell-root': {
    wordBreak: 'break-word',
    verticalAlign: 'top',
    px: 1,
    py: 0.75,
  },
};

const monospaceCellSx = { fontFamily: 'monospace', fontWeight: 600 };

export function renderHelpQuickbarSection(t) {
  return (
    <Box component="section" sx={{ mb: 3 }}>
      <Typography variant="subtitle1" component="h3" sx={{ fontWeight: 600, mb: 0.5 }}>
        {t('help.quickbar.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
        {t('help.quickbar.intro')}
      </Typography>
      <Table size="small" sx={helpTableSx} aria-label={t('help.quickbar.title')}>
        <TableHead>
          <TableRow>
            <TableCell component="th" scope="col" sx={{ width: '12%' }}>
              {t('help.quickbar.col.token')}
            </TableCell>
            <TableCell component="th" scope="col" sx={{ width: '38%' }}>
              {t('help.quickbar.col.meaning')}
            </TableCell>
            <TableCell component="th" scope="col">
              {t('help.quickbar.col.example')}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {HELP_QUICKBAR_ROWS.map((row) => (
            <TableRow key={row.id}>
              <TableCell sx={monospaceCellSx}>{row.token}</TableCell>
              <TableCell>{t(row.meaningKey)}</TableCell>
              <TableCell sx={monospaceCellSx}>{t(row.exampleKey)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography
        variant="body2"
        component="p"
        sx={{
          fontFamily: 'monospace',
          bgcolor: 'action.hover',
          p: 1,
          borderRadius: 1,
          mt: 1,
          wordBreak: 'break-word',
        }}
      >
        {t(HELP_QUICKBAR_FULL_EXAMPLE_KEY)}
      </Typography>
    </Box>
  );
}

export function renderHelpRestartSection(t, onRestartClick) {
  return (
    <Box component="section">
      <Typography variant="subtitle1" component="h3" sx={{ fontWeight: 600, mb: 0.5 }}>
        {t('help.restartIntro.title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
        {t('help.restartIntro.body')}
      </Typography>
      <Button variant="outlined" onClick={onRestartClick}>
        {t('help.restartIntro.confirm')}
      </Button>
    </Box>
  );
}
